import React, { useState } from "react";
import { Link } from "react-router-dom";
import MainPage from "../_layout/main.page";
import CompanyProfile from "../components/my-account/company-profile";
import ResetPassword from "../components/my-account/reset-password";
export const MyAccount = () => {
  //this below function stepform start//
  const [stepform, setActiveTab3] = useState("profile");
  const handleTabClick3 = (tab) => {
    setActiveTab3(tab);
  };

  //this below function stepform end//
  return (
    <div>
      <MainPage>
        <div className="page-body">
          <div className="my-account-wrapper  ">
            <div className="container">
              <div className="row">
                <div className="my-account-flex">
                  <div className="account-sidebar">
                    <aside>
                      <div className="asside-box">
                        <div className="aside-box-title">
                          <h5> My Account </h5>
                        </div>
                        <div className="aside-box-body">
                          <ul>
                            <li>
                              <Link to="#Profile" className={`tab ${stepform === "profile" ? "active" : " "}`} onClick={() => handleTabClick3("profile")}>
                                {" "}
                                Profile
                              </Link>
                            </li>
                            <li>
                              <Link to="#Reset-Password" className={`tab ${stepform === "ResetPassword" ? "active" : " "}`} onClick={() => handleTabClick3("ResetPassword")}>
                                {" "}
                                Reset Password
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </aside>
                  </div>
                  <div className="account-pages">
                    {stepform === "profile" && (
                      <>
                        <CompanyProfile />
                      </>
                    )}
                    {stepform === "ResetPassword" && (
                      <>
                        <ResetPassword />
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MainPage>
    </div>
  );
};
